module.exports = __webpack_public_path__ + "img/tablesCDsm.3ca0add1.png";